import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { routes, Route } from "../routes/routes";

const APP_NAME = "Influns";

const findRouteTitle = (
    routes: Route[],
    pathname: string
): string | null => {
    for (const route of routes) {
        if (route.path) {
            const match = matchPath({ path: route.path, end: true }, pathname);
            if (match && route.title) {
                return route.title;
            }
        }

        if (route.children) {
            const childTitle = findRouteTitle(route.children, pathname);
            if (childTitle) return childTitle;
        }
    }

    return null;
};

export const useDocumentTitle = () => {
    const location = useLocation();

    useEffect(() => {
        const title = findRouteTitle(routes, location.pathname);

        if (title) {
            document.title = `${title} - ${APP_NAME}`;
        } else {
            document.title = APP_NAME;
        }
    }, [location.pathname]);
};
